import { isNil } from 'lodash';
import { PixelRatio } from 'react-native';
import { MBView } from '@shared/components/MBView';
import { useSelector } from '@shared/store';
import { MBChatAttachmentProps } from '../index';
import { MBChatVideoAttachment } from './index';

const FALLBACK_WIDTH = 300;
const FALLBACK_HEIGHT = 169; // 16:9
const MAX_DIM = 1800;
const MAX_VIEWPORT_HEIGHT_PCT = 60;

export function MBChatVideoAttachmentWithPreview({
  attachment,
  style,
  isSending,
  progress,
  forcedHeight,
  containerWidth,
}: MBChatAttachmentProps) {
  const viewportWidth = useSelector(state => state.appState.viewportWidth);
  const viewportHeight = useSelector(state => state.appState.viewportHeight);
  const dpr = PixelRatio.get();
  const maxWidth = Math.min(
    MAX_DIM / dpr,
    !isNil(containerWidth) ? containerWidth * 0.75 : viewportWidth * 0.75,
  );
  // @ts-ignore -- strict migration: multiple diagnostics on next line
  const ratio = attachment.width / attachment.height;
  const maxHeight = Math.min(maxWidth / ratio, viewportHeight * (MAX_VIEWPORT_HEIGHT_PCT / 100));
  const usableWidth = Math.min(attachment.width || FALLBACK_WIDTH, maxWidth);
  const usableHeight = Math.min(attachment.height || FALLBACK_HEIGHT, maxHeight);
  let effectiveWidth = Math.min(maxWidth, usableWidth);
  let effectiveHeight = Math.min(maxHeight, usableHeight);
  const isLandscape = ratio >= 1;
  const isPortrait = ratio < 1;

  if (isLandscape) {
    effectiveHeight = effectiveWidth / ratio;
  }

  if (isPortrait) {
    effectiveWidth = effectiveHeight * ratio;
  }

  if (!isNil(forcedHeight)) {
    effectiveHeight = forcedHeight;
    effectiveWidth = effectiveHeight * ratio;
  }

  return (
    <MBView
      fill
      style={[
        style,
        {
          maxWidth: effectiveWidth,
          maxHeight: effectiveHeight,
          width: effectiveWidth,
          height: effectiveHeight,
        },
      ]}
      testID="MBChatVideoAttachmentWithPreview"
    >
      <MBChatVideoAttachment attachment={attachment} isSending={isSending} progress={progress} />
    </MBView>
  );
}
